var map = {
	"./de/triangle-icon.png": "YiXD",
	"./en/triangle-icon.png": "OFzQ",
	"./es/triangle-icon.png": "bOrA",
	"./fr/triangle-icon.png": "nRBF",
	"./ja/triangle-icon.png": "7I/B",
	"./ko/triangle-icon.png": "P+l4",
	"./pt/triangle-icon.png": "hENC",
	"./ru/triangle-icon.png": "Pzuq",
	"./tc/triangle-icon.png": "4pb9",
	"./th/triangle-icon.png": "IbKx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6HcR";